import { NgModule } from '@angular/core';
import { OnlyNumberDirective } from './onlynumber.directive';

@NgModule({
  declarations: [OnlyNumberDirective],
  exports: [OnlyNumberDirective],
})
export class OnlyNumberModule {}
